import(/* webpackMode: "eager" */ "/codebuild/output/src391911660/src/CVCircuit/frontend/app/global-error.tsx");
